import type { CityConfig } from "../city-template/types";

export const hickoryConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hickory",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "hickory",
  route: "/hickory",
  title: "Emergency Passport Hickory, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hickory, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Catawba County and the Catawba Valley region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Hickory, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hickory and Catawba Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20view%20of%20Hickory%20North%20Carolina%20downtown%20at%20golden%20hour%20with%20charming%20historic%20cityscape%2C%20modern%20furniture%20manufacturing%20district%2C%20warm%20afternoon%20sunlight%20over%20the%20Catawba%20Valley%2C%20lush%20green%20rolling%20hills%20and%20Lake%20Hickory%20visible%20in%20the%20background%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20suburban%20southern%20charm%2C%20no%20text%20or%20signs%20on%20buildings%2C%20clean%20modern%20town%20scene%20with%20natural%20mountain%20foothills%20atmosphere&width=1800&height=700&seq=hickory-hero-nc-001&orientation=landscape",
  heroImageAlt: "Hickory North Carolina downtown with Catawba Valley rolling hills and Lake Hickory",
  geoPosition: "35.7332;-81.3412",
  geoPlacename: "Hickory, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 240 miles from Hickory via I-85",
  },
  nearbyCitiesZips: [
    { name: "Hickory", zips: "28601, 28602, 28603" },
    { name: "Conover", zips: "28613" },
    { name: "Newton", zips: "28658" },
    { name: "Granite Falls", zips: "28630" },
    { name: "Taylorsville", zips: "28681" },
    { name: "Lenoir", zips: "28633, 28645" },
    { name: "Morganton", zips: "28655" },
    { name: "Valdese", zips: "28690" },
    { name: "Sawmills", zips: "28630" },
    { name: "Bethlehem", zips: "28630" },
    { name: "Long View", zips: "28601, 28602" },
    { name: "Icard", zips: "28666" },
    { name: "Rhodhiss", zips: "28667" },
    { name: "Hildebran", zips: "28637" },
    { name: "Drexel", zips: "28619" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Hickory departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Catawba Valley Coverage", desc: "Serving Hickory, Conover, and the western Piedmont region" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Fast passport renewal in Winston-Salem, NC", route: "/winston-salem" },
    { name: "Emergency passport help in Asheville, NC", route: "/asheville" },
    { name: "Urgent passport services in Greensboro, NC", route: "/greensboro" },
    { name: "Same-day passport help in Durham, NC", route: "/durham" },
    { name: "Passport courier services in High Point, NC", route: "/high-point" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hickory remotely via secure courier. We do not have a walk-in office in Hickory — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Catawba County and the Catawba Valley region travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Catawba County and the Catawba Valley region including Caldwell and Burke counties",
  serviceAreaIntro: "From downtown Hickory to the neighboring towns of Conover and Newton, from Granite Falls to Taylorsville and Lenoir — Fast Passport Center serves the entire Catawba Valley region. We regularly help travelers from Morganton, Valdese, Sawmills, and Bethlehem get their passports fast.",
  nearbyCitiesIntro: "We serve all Hickory neighborhoods and the surrounding Catawba Valley area including Conover, Newton, Granite Falls, Taylorsville, Lenoir, Morganton, Valdese, Sawmills, Bethlehem, Long View, Icard, Rhodhiss, Hildebran, and Drexel. If you are anywhere in Catawba, Caldwell, Burke, or Alexander counties, we have you covered.",
  howItWorksIntro: "Most Hickory travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Hickory travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Hickory and Catawba Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hickory? Here are the most common ones we hear from Catawba County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hickory international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Mark T.",
      location: "Hickory, NC",
      rating: 5,
      text: "My passport expired the week before our business trip to Germany. Fast Passport Center had my renewal in 4 days. Never had to leave the Catawba Valley. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer P.",
      location: "Conover, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in Italy. Got it in 28 hours. The team was incredibly responsive and compassionate. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Robert D.",
      location: "Newton, NC",
      rating: 5,
      text: "Business trip to Tokyo came up with 7 days notice. They got me a passport in 4 business days. The communication was outstanding throughout the entire process.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa S.",
      location: "Morganton, NC",
      rating: 5,
      text: "First passport for my daughter before her mission trip to Peru. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress. Truly grateful.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "hickory-1",
      name: "Hickory Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "245 1st Ave SW",
      city: "Hickory",
      state: "NC",
      zip: "28602",
      phone: "(828) 322-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Hickory",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hickory facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "hickory-2",
      name: "Conover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "815 1st St S",
      city: "Conover",
      state: "NC",
      zip: "28613",
      phone: "(828) 464-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East of Hickory",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Conover and eastern Catawba County residents. Less crowded than downtown Hickory.",
      icon: "ri-mail-line",
    },
    {
      id: "hickory-3",
      name: "Newton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 N Main Ave",
      city: "Newton",
      state: "NC",
      zip: "28658",
      phone: "(828) 464-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South of Hickory, Catawba County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Newton and southern Catawba County. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "hickory-4",
      name: "Morganton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "401 W Fleming Dr",
      city: "Morganton",
      state: "NC",
      zip: "28655",
      phone: "(828) 437-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West of Hickory, Burke County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Morganton and Burke County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "hickory-5",
      name: "Catawba County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "100 SW Blvd",
      city: "Newton",
      state: "NC",
      zip: "28658",
      phone: "(828) 695-6100",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Catawba County Courthouse, Newton",
      website: "https://www.catawbacountync.gov/",
      websiteLabel: "Catawba County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "hickory-6",
      name: "Lenoir Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "806 Blowing Rock Blvd",
      city: "Lenoir",
      state: "NC",
      zip: "28645",
      phone: "(828) 754-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North of Hickory, Caldwell County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lenoir and Caldwell County. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hickory photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Catawba County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hickory applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Catawba County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hickory travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hickory." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hickory address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hickory before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hickory for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Hickory?", a: "Fast Passport Center offers fast passport renewal in Hickory in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Hickory?", a: "The nearest regional passport agency to Hickory is the Atlanta Passport Agency, approximately 240 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Hickory without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Hickory?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Hickory — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Catawba County residents." },
    { q: "Do you serve the entire Catawba Valley region?", a: "Absolutely. Fast Passport Center serves the entire Catawba Valley region including Hickory, Conover, Newton, Granite Falls, Taylorsville, Lenoir, Morganton, Valdese, Sawmills, Bethlehem, Long View, Icard, Rhodhiss, Hildebran, and Drexel. Our courier service works seamlessly from any address in Catawba, Caldwell, Burke, or Alexander counties." },
    { q: "Can I expedite a child passport in Hickory?", a: "Yes. Fast Passport Center expedites child passports in Hickory for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Catawba County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hickory with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hickory", address: "2110 US-70 SE, Hickory, NC 28602", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Hickory", address: "2020 US-70 SE, Hickory, NC 28602", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Hickory", address: "2525 US-70 SE, Hickory, NC 28602", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Hickory", address: "2315 US-70 SE, Hickory, NC 28602", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Conover", address: "815 1st St S, Conover, NC 28613", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Newton", address: "1300 N Main Ave, Newton, NC 28658", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Morganton", address: "401 W Fleming Dr, Morganton, NC 28655", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Lenoir", address: "935 Blowing Rock Blvd, Lenoir, NC 28645", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Hickory",
      address: "1750 US-70 SE, Hickory, NC 28602",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Conover",
      address: "1010 1st St S, Conover, NC 28613",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Newton",
      address: "100 SW Blvd, Newton, NC 28658",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves southern Catawba County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Morganton",
      address: "700 E Union St, Morganton, NC 28655",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Burke County and western Catawba Valley. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "60 miles south of Hickory",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Primary airport for the Catawba Valley region. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles east of Hickory",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for the Triad region. Additional domestic routes with American and Delta.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "AVL",
      name: "Asheville Regional Airport",
      distance: "85 miles west of Hickory",
      address: "61 Terminal Dr, Fletcher, NC 28732",
      note: "Alternative airport for western North Carolina travelers. Additional domestic routes.",
      flightUrl: "https://flyavl.com/",
      flightLabel: "AVL Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Catawba County Register of Deeds',
      description: 'Marriage licenses and records for Catawba County. Apply in person or request certified copies.',
      url: 'https://www.catawbacountync.gov/departments/register-of-deeds/',
    },
    {
      label: 'Catawba County Clerk of Superior Court',
      description: 'Divorce records and decrees for Catawba County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/catawba-county/catawba-county-clerk-of-superior-court',
    },
  ],
};